import React from "react";
import Button from "../../Auth/button";
import classes from "./templateCard.module.css";
import { useHistory } from "react-router";
import { Popconfirm} from "antd";

import axios from "../../../Axios";
import {} from "../../../";
const uuid = require("uuid");
const Template = (props) => {
  const id = uuid();
  const history = useHistory();
  const click = () => {
    history.push("/view-template?id=" + props.id);
  };

  return (
    <div className={classes.card}>
      <div className={classes.txt}>
        {props.title}
        <div>
          <Popconfirm
            title="Are you sure to delete this template?"
            onConfirm={props.onDelete}
            onCancel={null}
            okText="Yes"
            cancelText="No"
          >
            <i
              className={[classes.delete, "fas fa-trash-alt"].join(" ")}
            ></i>
          </Popconfirm>
        </div>
      </div>

      <Button onClick={click} extraClass={classes.ButtonTemp}>
        View Template
      </Button>
    </div>
  );
};

export default Template;
